import { render, staticRenderFns } from "./InterestWithdrawal.vue?vue&type=template&id=cb1b271c&scoped=true&"
import script from "./InterestWithdrawal.vue?vue&type=script&lang=js&"
export * from "./InterestWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./InterestWithdrawal.vue?vue&type=style&index=0&id=cb1b271c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1b271c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
